import styled from 'styled-components';
import { isPlatform } from '@ionic/react';

export const PaymentSubscriptionWrapper = styled.div`
  margin-top: 4px;

  & .specialist-match {
    padding: 0;
  }

  & .specialist-stats {
    padding: 0;
  }

  & .review-section {
    & > div {
      padding: 0 !important;
    }

    & .swiper-slide {
      margin-right: 0 !important;
    }
  }
`;

export const PaymentSubscriptionInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  color: #1d201f;
  margin-bottom: 22px;

  & .info-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & .info-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  }

  & .info-description {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
  }

  & .info-total-price {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  .info-help {
    width: fit-content;
    display: flex;
    align-items: center;
    column-gap: 2px;
    outline: none;
    border: none;
    background: transparent;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #5b5b5b;

    & ion-icon {
      font-size: 20px;
    }
  }
`;

export const PaymentRow = styled.div`
  ${!isPlatform('desktop') &&
  `
      width: 100vw;
      position: relative;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
  `}

  border-bottom: 1px solid #eeeeee;
  padding: 25px ${!isPlatform('desktop') ? '16px' : 0};
`;

export const PaymentQuestionsButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  margin: 0 auto;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #1d201f;

  & ion-icon {
    font-size: 30px;
  }
`;

export const PaymentSkeletonRow = styled.div`
  display: flex;
  align-items: center;
`;

export const SpecialistName = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #1d201f;
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
